import { useState, useEffect } from 'react';
import { buildActivityFeed, feedCounts, mapNoteForFeed } from '../components/overview/activityFeed';

const axios = require('axios').default;

export default function useActivityFeed({ team, contact, csrfToken, notes = [], attachments = [], enabled = true }) {
  const [transactions, setTransactions] = useState([]);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    if (!team || !team.id || !contact || !contact.id) return;

    const fetchFeedSources = async () => {
      try {
        setLoading(true);
        if (csrfToken) {
          axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
        }

        const [transactionsRes, donationsRes] = await Promise.all([
          axios.get(`/teams/${team.id}/crm/fans/${contact.id}/transactions.json`, {
            params: { range: 'all_time', page: 1, per_page: 50 },
          }),
          axios.get(`/teams/${team.id}/crm/fans/${contact.id}/donations.json`, {
            params: { page: 1, per_page: 50 },
          }),
        ]);

        setTransactions(((transactionsRes.data || {}).events || []).map((t) => ({
          ...t,
          orderId: t.orders?.[0]?.id,
        })));
        setDonations(((donationsRes.data || {}).donations || []).map((d) => ({
          id: d.id,
          amount: d.amount,
          description: d.name,
          created_at: d.date,
        })));
      } catch (err) {
        setTransactions([]);
        setDonations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedSources();
  }, [team && team.id, contact && contact.id, csrfToken, enabled]);

  const feed = buildActivityFeed({ notes: notes.map(mapNoteForFeed), transactions, donations, attachments, teamId: team && team.id });
  const counts = feedCounts(feed);

  return { feed, counts, loading };
}
